import { render } from "./PtManageKey.vue?vue&type=template&id=317bd7be&scoped=true&ts=true"
import script from "./PtManageKey.vue?vue&type=script&lang=ts"
export * from "./PtManageKey.vue?vue&type=script&lang=ts"

import "./PtManageKey.vue?vue&type=style&index=0&id=317bd7be&lang=less&scoped=true"

import exportComponent from "/root/workspace/pt-manage-plugin-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317bd7be"]])

export default __exports__